import { useTranslation } from 'react-i18next';
import {
  PanelPageState,
  type PanelPageStateDomain,
} from '@/presentation/components/common/PanelPageState';

interface AccessDeniedProps {
  homeTo?: string | null;
  title?: string;
  message?: string;
  domain?: PanelPageStateDomain;
}

/** Sin permiso para la ruta — card centrada, CTA a la primera casa visible. */
export function AccessDenied({ homeTo, title, message, domain = 'default' }: AccessDeniedProps) {
  const { t } = useTranslation();

  return (
    <div
      className="flex h-full min-h-0 flex-1 items-center justify-center px-4 py-8 sm:px-6"
      data-testid="access-denied"
    >
      <PanelPageState
        variant="forbidden"
        layout="page"
        domain={domain}
        title={title ?? t('common.pageStates.forbidden.title')}
        message={message}
        homeTo={homeTo}
      />
    </div>
  );
}
